import OptIn from './OptIn'

export default OptIn
